// returns true if string is a positive integer
export const isPositiveInt = (value: string): boolean => {
    return /^-?\d+$/.test(value);
};

export const negative = (n: number): number => (n === 0 ? 0 : -n);
